<template>
    <div class="item-product rounded-lg overflow-hidden shadow mb-3 relative bg-white"  v-if="$parent.templateView == '' || $parent.templateView == 'list' || $parent.templateView == 'list_np'">
        <div class="relative" style="padding-bottom: 66.6%" v-if="item.image && $parent.templateView !== 'list_np'">
            <img class="absolute h-full object-cover w-full rounded" v-lazy="getLasyImage($root.getImage(item.image))" alt="" >
        </div>
        <div class="p-3" >
            <div class="flex items-center  justify-between gap-2">
                <div class="inline-block leading-tight font-medium text-black">                    
                    {{ item.title[$root.currentLanguage] }}
                    <span class="ml-1 -mb-1 inline-block relative" v-if="checkItemHasProperty(item) && !isPopup && checkTags(item)">
                        <svg class="w-4 h-4 fill-current" height="512pt" viewBox="0 0 512 512" width="512pt" xmlns="http://www.w3.org/2000/svg"><path d="m256 512c-141.164062 0-256-114.835938-256-256s114.835938-256 256-256 256 114.835938 256 256-114.835938 256-256 256zm0-480c-123.519531 0-224 100.480469-224 224s100.480469 224 224 224 224-100.480469 224-224-100.480469-224-224-224zm0 0"></path><path d="m368 272h-224c-8.832031 0-16-7.167969-16-16s7.167969-16 16-16h224c8.832031 0 16 7.167969 16 16s-7.167969 16-16 16zm0 0"></path><path d="m256 384c-8.832031 0-16-7.167969-16-16v-224c0-8.832031 7.167969-16 16-16s16 7.167969 16 16v224c0 8.832031-7.167969 16-16 16zm0 0"></path></svg>
                    </span>
                </div>
                <button class="block flex-shrink-0 h-8 px-4 sm:px-2 min-w-[8rem] text-center rounded-full"  
                    v-if="$parent.displayOrderButton" 
                    :class="[ $root.hotelCode == 'mercurekatowicecentrum' ? 'color-katowice' : '', $root.hotelCode == 'ibislondoncity' ? 'color-london' : '', $root.hotelCode == 'novotelcambridge' ? 'color-cambridge' : '', (!item.in_schedule || !section.in_schedule) ? 'bg-gray-200 text-gray-700' : 'text-white bg-accor-btn' ]" 
                    @click="$emit('click')" v-html="item.price > 0 ? $root.showPrice(item.price, item.is_price_from) : buttonOrderText">
                </button>
                <div class="font-semibold whitespace-no-wrap mx-2" v-else v-html="$root.showPrice(item.price, item.is_price_from)"></div>
            </div>
            <div class="ml-1 -mb-1 inline-block relative" v-if="item.product_icons.length > 0">
                <img v-for="(icon, index) in item.product_icons" :key="index"  class="mr-1 h-4 inline-block" :src="$root.getImage(icon)" alt="">
            </div>
            
            <template v-if="getFullDescr.length > 0">
                <div class="text-gray-600 text-sm pt-2" v-html="getFullDescr"></div>
            </template>

            <div v-if="section.files && section.files.length > 0">				
                <div class="text-xs flex justify-start items-center" v-for="(file, index) in section.files"  :key="index">													
                    <a :href="$root.getFile($root.getLangText(file.files))" v-if="$root.getImage($root.getLangText(file.files)).length > 0" class="py-2 my-2 px-4 min-w-[8rem] font-light uppercase bg-gray-100 text-black hover:bg-gray-200 text-center rounded-full focus:outline-none flex items-center justify-center border hover:text-black" target="_blank" style="text-decoration: none">
                        {{ file.title.length === 0 ? $root.getKeyWord('download') : $root.getLangText(file.title) }}
                    </a>
                </div>
            </div>
        </div>        
    </div>

    <div v-else-if="$parent.templateView == 'list_sm' || $parent.templateView == 'list_sm_np'">
        <div class="item-product bg-white rounded-2xl mb-3 p-3 rounded-xl shadow w-full flex gap-3">       
            <div class="bg-cover bg-top rounded-xl h-24 w-32 md:h-32 md:w-40 flex-shrink-0" v-if="$parent.templateView !== 'list_sm_np'">
                <img v-if="item.image" class=" h-full object-cover w-full rounded-xl" v-lazy="getLasyImage($root.getImage(item.image))" alt="">
                <img v-else class=" h-full object-cover w-full rounded-xl"  :src="require(`@/assets/image/loading_product.svg`)" >
            </div>                
            <div class="w-full flex flex-col justify-between">
                <div>
                    <div>
                        <div class="inline-flex">
                            <div :class="['leading-tight', 'truncate-text', $parent.displayOrderButton ? 'line-clamp-2' : '', 'text-black']" v-text="item.title[$root.currentLanguage]"></div>
                            <span class="mx-1 -mb-1 inline-block relative" v-if="checkItemHasProperty(item) && !isPopup">
                                <svg class="w-4 h-4 fill-current" height="512pt" viewBox="0 0 512 512" width="512pt" xmlns="http://www.w3.org/2000/svg"><path d="m256 512c-141.164062 0-256-114.835938-256-256s114.835938-256 256-256 256 114.835938 256 256-114.835938 256-256 256zm0-480c-123.519531 0-224 100.480469-224 224s100.480469 224 224 224 224-100.480469 224-224-100.480469-224-224-224zm0 0"></path><path d="m368 272h-224c-8.832031 0-16-7.167969-16-16s7.167969-16 16-16h224c8.832031 0 16 7.167969 16 16s-7.167969 16-16 16zm0 0"></path><path d="m256 384c-8.832031 0-16-7.167969-16-16v-224c0-8.832031 7.167969-16 16-16s16 7.167969 16 16v224c0 8.832031-7.167969 16-16 16zm0 0"></path></svg>
                            </span>
                        </div>
                        <span class="ml-1 inline-block relative mt-2" v-if="item.product_icons.length > 0">
                            <img v-for="(icon, index) in item.product_icons" :key="index"  class="mr-1 h-4 inline-block" :src="$root.getImage(icon)" alt="">
                        </span>
                        <template v-if="getFullDescr.length > 0">
                            <div class="text-gray-600 mt-2 text-xs" v-html="getFullDescr.replace('<pre>', '<div>')"></div>
                        </template>
                        <div v-if="section.files && section.files.length > 0">
                            <div class="flex justify-end items-center mb-2" v-for="(file, index) in section.files"  :key="index">											
                                <a :href="$root.getFile($root.getLangText(file.files))" v-if="$root.getImage($root.getLangText(file.files)).length > 0" class="product_add_cart flex items-center justify-center rounded-full flex-shrink-0 h-8 px-2 min-w-[8rem] text-sm text-center text-white uppercase" target="_blank" style="color: #fff">
                                    {{ file.title.length === 0 ? $root.getKeyWord('download') : $root.getLangText(file.title) }}
                                </a>
                            </div>
                        </div>                        
                    </div>
                </div>
                <div class="flex justify-end mt-2">
                    <button :class="[(!item.in_schedule || !section.in_schedule) ? 'bg-gray-200 text-gray-700' : 'bg-hotel text-white']" class="h-8 min-w-[8rem] sm:w-40 px-2 text-center rounded-full" 
                        v-if="$parent.displayOrderButton" 
                        v-html="item.price > 0 ? $root.showPrice(item.price, item.is_price_from) : buttonOrderText">
                    </button>
                    <div class="font-semibold whitespace-no-wrap mx-2" v-else v-html="$root.showPrice(item.price, item.is_price_from)"></div>
                </div>
            </div>
        </div>
    </div>    

    <div v-else>
        <div class="item-product bg-white rounded-2xl  h-full flex flex-col justify-between shadow">
            <div>
                <div class="relative" style="padding-bottom: 66.6%" v-if="$parent.templateView !== 'grid_np'">
                    <img  v-if="item.image" class="absolute h-full object-cover w-full rounded-t-2xl" v-lazy="getLasyImage($root.getImage(item.image))" alt="" >
                    <img  v-else class="absolute h-full object-cover w-full rounded-t-2xl"  :src="require(`@/assets/image/loading_product.svg`)" >
                </div>
                <!--<div class="bg-cover bg-top rounded-t-xl h-32 md:h-40" v-if="item.image" style="background-image: url(https://admin.2roomz.com/storage/products/Nh8QxzEKUeSB8mzaG7NeHTzWtanGBH5NpDqHzPKg.jpeg);">
                </div>-->
                <div class="p-3">
                    <div>
                        <div class="inline-flex">
                            <div :class="['leading-tight', $parent.displayOrderButton ? 'line-clamp-2' : '', 'text-black']" v-text="item.title[$root.currentLanguage]"></div>
                            <span class="mx-1 -mb-1 inline-block relative" v-if="checkItemHasProperty(item) && !isPopup">
                                <svg class="w-4 h-4 fill-current" height="512pt" viewBox="0 0 512 512" width="512pt" xmlns="http://www.w3.org/2000/svg"><path d="m256 512c-141.164062 0-256-114.835938-256-256s114.835938-256 256-256 256 114.835938 256 256-114.835938 256-256 256zm0-480c-123.519531 0-224 100.480469-224 224s100.480469 224 224 224 224-100.480469 224-224-100.480469-224-224-224zm0 0"></path><path d="m368 272h-224c-8.832031 0-16-7.167969-16-16s7.167969-16 16-16h224c8.832031 0 16 7.167969 16 16s-7.167969 16-16 16zm0 0"></path><path d="m256 384c-8.832031 0-16-7.167969-16-16v-224c0-8.832031 7.167969-16 16-16s16 7.167969 16 16v224c0 8.832031-7.167969 16-16 16zm0 0"></path></svg>
                            </span>
                        </div>
                        <span class="ml-1 inline-block relative" v-if="item.product_icons.length > 0">
                            <img v-for="(icon, index) in item.product_icons" :key="index"  class="mr-1 h-4 inline-block" :src="$root.getImage(icon)" alt="">
                        </span>
                        <template v-if="getFullDescr.length > 0">
                            <div class="text-gray-600 mt-2 text-xs" v-html="getFullDescr"></div>
                        </template>
                        <div v-if="section.files && section.files.length > 0">
                            <div class="flex justify-end items-center mb-2" v-for="(file, index) in section.files"  :key="index">											
                                <a :href="$root.getFile($root.getLangText(file.files))" v-if="$root.getImage($root.getLangText(file.files)).length > 0" class="product_add_cart flex items-center justify-center rounded-full flex-shrink-0 h-8 px-2 min-w-[8rem] text-sm text-center text-white uppercase" target="_blank" style="color: #fff">
                                    {{ file.title.length === 0 ? $root.getKeyWord('download') : $root.getLangText(file.title) }}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="p-3 ">
                <button :class="[(!item.in_schedule || !section.in_schedule) ? 'bg-gray-200 text-gray-700' : 'bg-hotel text-white']" class="h-8 px-2 w-full text-center rounded-full" 
                    v-if="$parent.displayOrderButton" 
                    v-html="item.price > 0 ? $root.showPrice(item.price, item.is_price_from) : buttonOrderText">
                </button>
                <div class="font-semibold whitespace-no-wrap mx-2" v-else v-html="$root.showPrice(item.price, item.is_price_from)"></div>
            </div>
        </div>
    </div>    
</template>

<script>
export default {
    props: [
        'item', 
        'isPopup', 
        'section', 
        'getShortDescr', 
        'getFullDescr',
        'buttonOrderText'],
    methods: {
        checkItemHasProperty(item) {
            try {
                return item.property !== null && item.property.properties.length > 0;
            } catch(e) {
                console.error(e);

                return false;
            }
        },
        checkTags(item){
          if(item.tags){
              return item.tags.filter(tag => {
                return tag.ptag_id && tag.ptag_id == 'spa'
              }).length > 0 ? false : true
          }
          return true
        }
    }
}
</script>